import { Component, OnDestroy, OnInit } from "@angular/core";
import { WebsiteAttributesService } from "../services/website-attributes.service";
import { LanguageService } from "../services/language.service";
import { Subscription } from "rxjs";
import { DynamicDialogRef } from "primeng/dynamicdialog";


@Component({
  template:'',
  selector: 'app-product-cell-mobile',

})
export class BaseComponent implements OnInit,OnDestroy
{

  currency: string = 'EGP';
  attributesObject?:any
  lang:string =  'en';
  public subscriptions : Subscription[] = [];
  ref: DynamicDialogRef | undefined;


constructor(public language_s?:LanguageService,public attrService?:WebsiteAttributesService){


}

  ngOnInit(): void {
    this.set_language()
    this.set_currency()
  }
  set_currency()
  {


    // catch css variables
    let css_root : any = document.querySelector(":root");
    let gcs_root = window.getComputedStyle(css_root);

    // get css varibales data

    this.subscriptions?.push(
      this.attrService?.get_site_attributes().subscribe((e:any)=>{
      this.currency = e!.currency!;
      this.attributesObject = e
    })!
    )


  }


  set_language()
  {
    this.lang = this.language_s?.get_site_active_lang_code() || 'ar';

  }
  ngOnDestroy(): void {
    if(this.subscriptions.length > 0) {
      this.subscriptions?.forEach((subscription) => {
        console.log(subscription)
        if(subscription){
      subscription.unsubscribe();
        }
    });
  }
  }


}
